import * as yup from 'yup';

export const JackpotWinnersFormSchema = yup.object({
  gameId: yup.string().required(),
  app: yup.string().required(),
});

export type JackpotWinnersFormData = yup.InferType<typeof JackpotWinnersFormSchema>;
